export const toggleCollapse = 'toggleCollapse'
export const dialogHide = 'dialogHide'
export const loadingStop = 'loadingStop'
export const resetStop = 'resetStop'
export const ADD_ITEMS = 'ADD_ITEMS'
export const SWITCH_PAGE = 'SWITCH_PAGE'
export const LOGIN_MODEL = 'LOGIN_MODEL'
export const IS_FUZZY_VERIFY = 'IS_FUZZY_VERIFY'
export const SET_MCA_SWITCH = 'SET_MCA_SWITCH'
export const SET_PRINT_TYPE = 'SET_PRINT_TYPE'
export const COLLAPSE_ALL_SIDE = 'COLLAPSE_ALL_SIDE'
export const setCollapse = 'setCollapse'
export const SET_PERSONALIZED_SELECT_RANGE_CACHE = 'SET_PERSONALIZED_SELECT_RANGE_CACHE'

